"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.EligibilityCriteriaCalculationSchema = void 0;
const _imports_1 = require("./_imports");
const _shared_1 = require("./_shared");
// Zod schema for EligibilityCriteriaCalculation
exports.EligibilityCriteriaCalculationSchema = _imports_1.z.object({
    eligibilityCriteriaKey: _imports_1.z.string(),
    eligibilityReduction: _imports_1.z.number(),
});
// Zod schemas for EligibilityTest.Config (discriminated union)
const PointerConfigSchema = _imports_1.z.object({
    method: _imports_1.z.string(),
});
const FormulaTestSchema = _imports_1.z.object({
    propertyKey: _imports_1.z.string(),
    type: _imports_1.z.literal('formula'),
    config: _shared_1.FormulaConfigSchema,
});
const PointerTestSchema = _imports_1.z.object({
    propertyKey: _imports_1.z.string(),
    type: _imports_1.z.literal('pointer'),
    config: PointerConfigSchema,
});
exports.ConfigSchema = _imports_1.z.discriminatedUnion('type', [
    FormulaTestSchema,
    PointerTestSchema,
]);
//# sourceMappingURL=EligibilityTest.js.map